export default __webpack_public_path__ + "static/HelpScout-13000420876bd87ac98acb89adf7ab12.png";